import { Colors } from 'enums';
import * as S from './Badge.styles';

export type BadgeProps = {
  label: string;
  backgroundColor: string;
  textColor?: string;
  className?: string;
  'data-testid'?: string;
};

export const Badge = ({
  label,
  backgroundColor,
  textColor = Colors.gray1,
  className,
  'data-testid': dataTestId,
}: BadgeProps) => {
  return (
    <S.Badge
      className={className}
      $backgroundColor={backgroundColor}
      $textColor={textColor}
      data-testid={dataTestId}
    >
      <S.BadgeLabel kind='small2' $textColor={textColor}>
        {label}
      </S.BadgeLabel>
    </S.Badge>
  );
};
